import React from 'react';
import Widget from './widget';
// import {get} from 'lodash';
import nprops from 'nested-props';
import esriStrings from '../../resources/esriStrings';
import layerUrls from '../../resources/vtlayers';
import PopChart from './popchart';
import BarChart from './barchart';

const defaultData = [
  [
    {
      year: esriStrings.barchartCurrent,
      val: (165000 / 1000).toFixed(2)
    },
    {
      year: esriStrings.barchartFuture,
      val: (165000 / 1000).toFixed(2)
    }
  ],
  [
    {
      year: esriStrings.barchartCurrent,
      val: (41000000 / 1000000).toFixed(2)
    },
    {
      year: esriStrings.barchartFuture,
      val: (41000000 / 1000000).toFixed(2)
    }
  ]
];

const Population = (props) => {
  const [popData, setPopData] = React.useState(defaultData);
  React.useEffect(() => {
    if (props.isActive) {
      props.onUpdateLayer(layerUrls.population);
      props.setActiveLegend('population');
    }
  }, [props.isActive]);

  React.useEffect(() => {
    const fields = nprops.get(props.currentFeature, 'attributes.pop', null);
    if (fields) {
      setPopData([
        [
          {
            year: esriStrings.barchartCurrent,
            val: ((fields.total_pop_cy || 0) / 1000).toFixed(2)
          },
          {
            year: esriStrings.barchartFuture,
            val: ((fields.total_pop_fy || 0) / 1000).toFixed(2)
          }
        ],
        [
          {
            year: esriStrings.barchartCurrent,
            val: ((fields.total_state_pop_cy || 0) / 1000000).toFixed(2)
          },
          {
            year: esriStrings.barchartFuture,
            val: ((fields.total_state_pop_fy || 0) / 1000000).toFixed(2)
          }
        ]
      ]);
    }
  }, [props.currentFeature]);
  const handleShow = () => {
    props.onWidget(4);
  };

  return (
    <Widget
      info={props.info}
      isActive={props.isActive}
      title={esriStrings.widgetFour}
      onWidget={handleShow}
    >
      <div className="pop-chart-wrapper" onClick = {() => {
        handleShow();
      }}>
        <BarChart data={popData[0]} chartLabel="ZIP Code" numInital=" K" />
        <BarChart data={popData[1]} chartLabel="State" numInital=" M" />
      </div>
    </Widget>
  );
};

export default Population;
